import clsx from 'clsx';
import { logoutFn } from './store';

export function Button(props: {
  onClick: () => void;
  primary?: boolean;
  danger?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  const { onClick, disabled, primary, danger, children } = props;
  return (
    <button
      className={clsx(
        'px-4 py-2 mt-4 text-sm font-medium text-white bg-blue-600 rounded-md',
        primary && 'bg-artis-primary text-gray-900',
        danger && 'bg-red-600 hover:bg-red-700 text-white',
        disabled
          ? 'bg-gray-300 cursor-not-allowed'
          : !danger && 'hover:bg-blue-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75',
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export function LogoutButton() {
  return (
    <Button danger onClick={() => logoutFn()}>
      Log out
    </Button>
  );
}
